import type { IExercise } from '../exercises';

export const HOME_EPISODE_01_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-home-01-01",
    "name": "弹力带胸部激活",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "chest",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "demoUrl": "/media/collections-20261008/demos/mobile-9619d061ea37ad7138f74ea7.mp4",
    "videoUrl": "/media/collections-20261008/videos/ca8dc1fcae6cadf5bcef33fc.mp4",
    "source": "居家训练 · 第1期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-01-02",
    "name": "靠墙倒立",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 3,
    "reps": "30秒",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌前束", "三角肌中束"],
    "demoUrl": "/media/collections-20261008/demos/mobile-7ba8292e57065146262791ec.mp4",
    "videoUrl": "/media/collections-20261008/videos/abaac11e418fa9a45bbc488c.mp4",
    "source": "居家训练 · 第1期",
    "isWarmup": true,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-01-03",
    "name": "哑铃平板卧推",
    "bodyPart": "chest",
    "equipment": "dumbbell",
    "subCategory": "mid-chest",
    "tips": ["仰卧地面持哑铃推起", "按教学控制上臂触地与推起节奏"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌", "三角肌前束"],
    "demoUrl": "/media/collections-20261008/demos/mobile-0dd1d11b9556b739d34a06a4.mp4",
    "videoUrl": "/media/collections-20261008/videos/874b7b03e1097463a13599ff.mp4",
    "source": "居家训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-01-04",
    "name": "哑铃俯卧撑",
    "bodyPart": "chest",
    "equipment": "dumbbell",
    "subCategory": "mid-chest",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "力竭",
    "rpe": 9,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌", "三角肌前束"],
    "demoUrl": "/media/collections-20261008/demos/mobile-8628c6af12de20292c2e2369.mp4",
    "videoUrl": "/media/collections-20261008/videos/d8f7c8788fe0af2a626e4b94.mp4",
    "source": "居家训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-01-05",
    "name": "哑铃飞鸟",
    "bodyPart": "chest",
    "equipment": "dumbbell",
    "subCategory": "inner-chest",
    "tips": ["仰卧地面持哑铃做飞鸟夹胸", "按教学控制幅度与节奏"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌中缝", "前锯肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-3d36b572a809b27e9f769b13.mp4",
    "videoUrl": "/media/collections-20261008/videos/f554c4d79c21e09fde3596d6.mp4",
    "source": "居家训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-01-06",
    "name": "俯卧反向飞鸟",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": false,
    "difficulty": "beginner",
    "targetMuscles": ["三角肌后束", "菱形肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-b8de6a74d2b221d2e8dc8f30.mp4",
    "videoUrl": "/media/collections-20261008/videos/17aa4cbbe56455912baf9c5e.mp4",
    "source": "居家训练 · 第1期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-01-07",
    "name": "坐姿颈后臂屈伸",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌", "肘肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-20f09baa58dd2b4b41096b89.mp4",
    "videoUrl": "/media/collections-20261008/videos/8aa465d9b87b27ca89551391.mp4",
    "source": "居家训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-01-08",
    "name": "俯身哑铃臂屈伸",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌", "肘肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-a059c2b0df3e7ac117b07e43.mp4",
    "videoUrl": "/media/collections-20261008/videos/de4eeb83f1c5ce0aac2d7902.mp4",
    "source": "居家训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
